/** Per-surface config for blanket basic information (Phase 9.9F). */

export const BLANKET_BASIC_INFO_CONFIG = {
  creation: {
    surface: "creation",
    showProfessionalGuardianLink: false,
    residencyStatusSource: "watch",
    emailHandler: "fieldChange",
    formatSSNMode: "inline",
  },
  historic: {
    surface: "historic",
    showProfessionalGuardianLink: true,
    residencyStatusSource: "prop",
    emailHandler: "debounceRef",
    formatSSNMode: "prop",
  },
};
